import { render, staticRenderFns } from "./ExperimentTicket.vue?vue&type=template&id=5cd5fa7b&scoped=true"
import script from "./ExperimentTicket.vue?vue&type=script&lang=js"
export * from "./ExperimentTicket.vue?vue&type=script&lang=js"
import style0 from "./ExperimentTicket.vue?vue&type=style&index=0&id=5cd5fa7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5fa7b",
  null
  
)

export default component.exports